import { render, staticRenderFns } from "./DashboardCompanyDB.vue?vue&type=template&id=e2c86f9e&scoped=true&"
import script from "./DashboardCompanyDB.vue?vue&type=script&lang=js&"
export * from "./DashboardCompanyDB.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCompanyDB.vue?vue&type=style&index=0&id=e2c86f9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c86f9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VContainer,VIcon,VProgressCircular})
